var SwipeDirection;
(function (SwipeDirection) {
    SwipeDirection["Left"] = "Left";
    SwipeDirection["Right"] = "Right";
    SwipeDirection["Up"] = "Up";
    SwipeDirection["Down"] = "Down";
})(SwipeDirection || (SwipeDirection = {}));

export { SwipeDirection };
